export class BridgeTimeoutError extends Error {
	constructor(messageType: string) {
		super(`Timeout waiting for ${messageType} response`);
		this.name = "BridgeTimeoutError";
	}
}
